import { documentApi } from "@api/documents";
import { withCancel } from "@api/utils";
import { SeeAllButton } from "@components/backoffice/buttons/SeeAllButton";
import { Error } from "@components/Error";
import { Loader } from "@components/Loader";
import { ResultsTable } from "@components/ResultsTable/ResultsTable";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import { BackOfficeRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

export class PendingOverdueDocumentsList extends Component {
  constructor(props) {
    super(props);

    this.query = documentApi.query().pendingOverdue().qs();

    this.state = {
      data: { hits: [], total: 0 },
      isLoading: true,
      error: {},
    };
  }

  componentDidMount() {
    this.fetch();
  }

  componentWillUnmount() {
    this.cancellableFetch && this.cancellableFetch.cancel();
  }

  fetch = async () => {
    this.cancellableFetch = withCancel(documentApi.list(this.query));
    this.setState({ isLoading: true });
    try {
      const response = await this.cancellableFetch.promise;
      this.setState({ data: response.data, isLoading: false, error: {} });
    } catch (error) {
      if (error !== "UNMOUNTED") {
        this.setState({ isLoading: false, error: error });
      }
    }
  };

  seeAllButton = () => {
    const path = BackOfficeRoutes.documentsListWithQuery(this.query);
    return <SeeAllButton to={path} />;
  };

  viewDetails = ({ row }) => {
    return (
      <Button
        as={Link}
        to={BackOfficeRoutes.documentDetailsFor(row.metadata.pid)}
        compact
        icon="info"
        data-test={row.metadata.pid}
      />
    );
  };

  renderTable(data) {
    const { showMaxEntries } = this.props;
    const columns = [
      { title: "", field: "", formatter: this.viewDetails },
      { title: "Document", field: "metadata.pid" },
      {
        title: "Title",
        field: "",
        formatter: ({ row }) => (
          <LiteratureTitle
            title={row.metadata.title}
            edition={row.metadata.edition}
            publicationYear={row.metadata.publication_year}
          />
        ),
      },
      {
        title: "Overdue Loans",
        field: "metadata.circulation.overdue_loans_count",
      },
      {
        title: "Pending Requests",
        field: "metadata.circulation.pending_loans_count",
      },
    ];
    return (
      <ResultsTable
        data={data.hits}
        columns={columns}
        totalHitsCount={data.total}
        title="Pending overdue documents"
        subtitle="Documents with pending loan requests, no available items and an active loan that's overdue."
        name="pending overdue documents"
        seeAllComponent={this.seeAllButton()}
        showMaxRows={showMaxEntries}
      />
    );
  }

  render() {
    const { data, isLoading, error } = this.state;
    return (
      <Loader isLoading={isLoading}>
        <Error error={error}>{this.renderTable(data)}</Error>
      </Loader>
    );
  }
}

PendingOverdueDocumentsList.propTypes = {
  showMaxEntries: PropTypes.number,
};

PendingOverdueDocumentsList.defaultProps = {
  showMaxEntries: 5,
};
